import { render } from "./HomeNewsItem.vue?vue&type=template&id=f29e47ce&scoped=true"
import script from "./HomeNewsItem.vue?vue&type=script&lang=js"
export * from "./HomeNewsItem.vue?vue&type=script&lang=js"

import "./HomeNewsItem.vue?vue&type=style&index=0&id=f29e47ce&scoped=true&lang=css"

import exportComponent from "D:\\前端\\暂存\\官网\\romenswebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f29e47ce"]])

export default __exports__